var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPawPrint01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 63 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.833,0c-4.602,0 -8.333,3.731 -8.333,8.333l-0,4.167c-0,4.602 3.731,8.333 8.333,8.333c4.603,0 8.334,-3.731 8.334,-8.333l-0,-4.167c-0,-4.602 -3.731,-8.333 -8.334,-8.333Z",
    style: {
      fill: "#303030",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.667,0c-4.603,0 -8.334,3.731 -8.334,8.333l0,4.167c0,4.602 3.731,8.333 8.334,8.333c4.602,0 8.333,-3.731 8.333,-8.333l0,-4.167c0,-4.602 -3.731,-8.333 -8.333,-8.333Z",
    style: {
      fill: "#303030",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.333,20.833c-4.602,0 -8.333,3.731 -8.333,8.334l0,2.083c0,4.602 3.731,8.333 8.333,8.333c4.603,0 8.334,-3.731 8.334,-8.333l-0,-2.083c-0,-4.603 -3.731,-8.334 -8.334,-8.334Z",
    style: {
      fill: "#303030",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.167,20.833c-4.603,0 -8.334,3.731 -8.334,8.334l0,2.083c0,4.602 3.731,8.333 8.334,8.333c4.602,0 8.333,-3.731 8.333,-8.333l0,-2.083c0,-4.603 -3.731,-8.334 -8.333,-8.334Z",
    style: {
      fill: "#303030",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.053,32.412c-4.562,-5.539 -13.044,-5.539 -17.606,0l-12.158,14.763c-5.033,6.112 -0.685,15.325 7.233,15.325c1.131,0 2.247,-0.263 3.258,-0.769l1.499,-0.75c5.647,-2.823 12.295,-2.823 17.942,0l1.499,0.75c1.011,0.506 2.127,0.769 3.258,0.769c7.918,0 12.266,-9.213 7.233,-15.325l-12.158,-14.763Z",
    style: {
      fill: "#303030",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawPrint01);
export default __webpack_public_path__ + "static/media/paw-print-01.7df483a062fe6ab9dc19adaf400de697.svg";
export { ForwardRef as ReactComponent };